import { render, staticRenderFns } from "./personalTraining.vue?vue&type=template&id=39b7640e&scoped=true"
import script from "./personalTraining.vue?vue&type=script&lang=js"
export * from "./personalTraining.vue?vue&type=script&lang=js"
import style0 from "./personalTraining.vue?vue&type=style&index=0&id=39b7640e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b7640e",
  null
  
)

export default component.exports